import { useEffect, useState } from 'react'

export const useLogoPathBySlug = (slugs: (string | undefined | null)[] = []) => {
  const uniqueSlugs = Array.from(new Set(slugs.filter((s): s is string => Boolean(s))))

  const [logoPathBySlug, setLogoPathBySlug] = useState<Record<string, string>>({})

  useEffect(() => {
    if (!uniqueSlugs.length) {
      setLogoPathBySlug({})
      return
    }

    const getAllSourceImages = async () => {
      await Promise.all(
        uniqueSlugs.map(async (slug) => {
          try {
            // WHY CAN'T WE USE ABSOLUTE PATHS HERE????
            const response = await import(`../../assets/logos/${slug}.svg`)

            setLogoPathBySlug((prev) => ({
              ...prev,
              [slug]: response.default,
            }))
          } catch (err) {}
        })
      )
    }

    getAllSourceImages()
  }, [JSON.stringify(uniqueSlugs)])

  return logoPathBySlug
}
